module.exports = __webpack_public_path__ + "img/qq-icon.021516ba.png";